import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/**
 * The whole interview list is fetched in one shot, like facilities and staff members: the screen
 * only ever sorts what it already holds, client-side. `page`/`rows` are not client concerns —
 * `fetchInterviews` walks every server page itself, via `getPaginated`.
 */
class FetchInterviews {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly orderByCreatedAt: 'ASC' | 'DESC' = 'DESC',
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const queryParams = new URLSearchParams({
			orderByCreatedAt: this.orderByCreatedAt,
		});

		return queryParams.toString();
	}
}

export default FetchInterviews;
